module.exports = __webpack_public_path__ + "img/mz.ee2126c6.svg";